import { render, staticRenderFns } from "./automaticLoginIcon.vue?vue&type=template&id=128f321e&scoped=true"
import script from "./automaticLoginIcon.vue?vue&type=script&lang=js"
export * from "./automaticLoginIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128f321e",
  null
  
)

export default component.exports